import React from "react";
import { createPortal } from "react-dom";

export interface ResizePointerShimProps {
  /** When true, a transparent layer covers the viewport so embedded documents (e.g. iframes) cannot steal pointer events during a column resize. */
  active: boolean;
  cursor?: React.CSSProperties["cursor"];
}

/**
 * Iframes (HTML preview, PDF, etc.) consume pointer events in their own document.
 * Document-level `mousemove` then stops firing, which breaks splitter drags.
 * This portal keeps the drag alive until `mouseup`.
 */
const ResizePointerShim: React.FC<ResizePointerShimProps> = ({
  active,
  cursor = "col-resize",
}) => {
  if (!active || typeof document === "undefined") return null;

  return createPortal(
    <div
      aria-hidden
      className="fixed inset-0"
      style={{
        zIndex: 10000,
        cursor,
        userSelect: "none",
        touchAction: "none",
        background: "transparent",
      }}
    />,
    document.body,
  );
};

export default ResizePointerShim;
